import Gear from '../src/Gear';
export default Gear;
